import BasePopup from '../BasePopup';
import useTranslation from 'next-translate/useTranslation';
import { Namespace } from 'enums/namespaces';
import { useCallback } from 'react';
import { setCookie } from 'nookies';
import { CookiesType, PopupType } from 'enums';
import { getSharedApiClient } from 'api/client';
import { signCookie } from 'helpers';
import { CookieAnalytics } from 'enums/cookieAnalytics';
import { usePopup } from 'context';

interface Props {
  onClose?: () => void;
  onAccept: () => void;
}

const CookiesBar = ({ onClose, onAccept }: Props): JSX.Element => {
  const { t } = useTranslation(Namespace.Common);
  const { setPopupConfig } = usePopup();

  const sendAnalytics = useCallback(async () => {
    const [signature, salt] = signCookie(CookieAnalytics.ALL);

    await getSharedApiClient().cookieAnalytics({
      option: CookieAnalytics.ALL,
      signature,
      salt,
    });
  }, []);

  const onLearnMore = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setPopupConfig({
      popupType: PopupType.Cookies,
      onClose: () => {
        setPopupConfig(null);
      },
    });
  }, []);

  const _onAccept = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setPopupConfig(null);
    setCookie(null, CookiesType.AllowAnalytics, 'true', {
      maxAge: 3600 * 24 * 365 * 2,
      path: '/',
    });
    sendAnalytics();
    onAccept();
  }, []);

  return (
    <BasePopup
      showCloseIcon={false}
      classes={['cookies-bar']}
      closeOnEscape={false}
      onClose={onClose}
      showOverlay={false}
      allowBackgroundScrolling
    >
      <p>{t('cookies_bar.less_text')}</p>
      <div className="buttons">
        <a onClick={onLearnMore} className="btn btn-cancel" href="#">
          {t('cookies_bar.learn_more')}
        </a>
        <a onClick={_onAccept} className="btn btn-primary" href="#">
          {t('cookies_bar.accept_all')}
        </a>
      </div>
    </BasePopup>
  );
};

export default CookiesBar;
